import { DS_BREAKPOINT, PRIMITIVES } from '@calm/evexia-design-tokens';

export const BANNER_V2_HEIGHT = 450;

/** Approximate BannerCardV3Mobile height in the DynamicHomeRecommendations carousel.
 *  Unlike BANNER_V2_HEIGHT (a CSS hard cap), this is empirically measured — the mobile
 *  card height emerges from maxWidth: min-content on CarouselItem constraining the card
 *  to its intrinsic content width. Update if card content or layout changes significantly. */
export const BANNER_V3_MOBILE_HEIGHT = 285;

export const BANNER_V2_MAX_WIDTH =
    DS_BREAKPOINT.ULTRA - 2 * PRIMITIVES.spacing._32; // 1376;

/** The V3 banner image renders full-bleed (fillContainer) inside a bounded card,
 *  so without an explicit `sizes` next/image assumes 100vw and over-fetches (a
 *  ~688px slot pulling a 2880px rendition). These describe the image's real slot.
 *
 *  Desktop: a 2-column grid inside a card capped at BANNER_V2_MAX_WIDTH, so the
 *  image is ~50vw until the card maxes out, then half the max width. */
const BANNER_V3_DESKTOP_IMAGE_COLUMN_WIDTH = Math.round(
    BANNER_V2_MAX_WIDTH / 2
);
export const BANNER_V3_DESKTOP_IMAGE_SIZES = `(min-width: ${BANNER_V2_MAX_WIDTH}px) ${BANNER_V3_DESKTOP_IMAGE_COLUMN_WIDTH}px, 50vw`;
/** Mobile: the image spans the full width of the (near-full-width) card. */
export const BANNER_V3_MOBILE_IMAGE_SIZES = '94vw';
